import { useToggle } from 'react-use';
import { Common } from '@thecvlb/design-system/lib/src';

import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';
import AdvantageItem from 'features/AdvantageItem';

import { BLUE_LINE_ADVANTAGES } from 'utils/constants';
import { calculateDiscountPercentageByPrices } from 'utils/helpers';

import Heading from '../../components/Heading';
import WMQuestionsList from '../parts/QuestionsList';
import { BL_SELECT_PLAN_FAQ } from '../SelectPlan/SelectPlan';

const YourWeightLossProgram: React.FC<BasicSignupStepProps> = ({ moveToStep }) => {
  const [isExtended, toggle] = useToggle(false);

  return (
    <div className="flex h-full flex-col gap-6">
      <Heading category="Sign up" title="Your weight loss program" />
      <div className="rounded-2xl border">
        <div className="flex items-center justify-between rounded-t-2xl bg-primary-100 p-4 text-primary">
          <span className="text-mSm font-bold">
            {calculateDiscountPercentageByPrices(59, 149)}% OFF DISCOUNT APPLIED
          </span>
          <Common.Icon name="check" />
        </div>
        <div className="rounded-b-2xl bg-gray-100 p-4">
          <div className="mb-3 flex flex-col gap-3">
            <h3 className="font-bold text-primary-700">LifeMD GLP-1 Weight Management Program:</h3>
            <span className="text-mSm md:text-sm">
              Join today for <span className="line-through">$149</span> $59 for per month.
            </span>
          </div>
          <div className="flex flex-col">
            {isExtended && (
              <div className="flex flex-col gap-2 p-2">
                {BLUE_LINE_ADVANTAGES.map((el) => (
                  <AdvantageItem advantage={el} key={el} showCustomIcon />
                ))}
              </div>
            )}
            <Common.Button
              color="white-alt"
              postIcon={isExtended ? 'arrow-up' : 'arrow-down'}
              fullWidthOnMobile
              onClick={toggle}
            >
              {isExtended ? 'Show less' : 'Learn more'}
            </Common.Button>
          </div>
        </div>
      </div>
      <div>
        <h3 className="text-xl font-semibold text-primary-700">FAQs</h3>
        <WMQuestionsList questions={BL_SELECT_PLAN_FAQ} />
      </div>
      <Common.Button
        className="mx-auto mb-10 !w-[290px] max-md:hidden"
        color="blue"
        dataTestId="continue-btn"
        postIcon="arrow-right"
        size="lg"
        fullWidthOnMobile
        onClick={() => moveToStep('next')}
      >
        Continue
      </Common.Button>
      <Common.Button
        className="sticky bottom-6 z-10 mt-auto md:hidden"
        color="blue"
        dataTestId="continue-btn"
        postIcon="arrow-right"
        size="lg"
        fullWidthOnMobile
        onClick={() => moveToStep('next')}
      >
        Continue
      </Common.Button>
    </div>
  );
};

export default YourWeightLossProgram;
